import { Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import logo from "../../../../assets/logos/text-logo-black.svg";
import Button from "../../../common/Button/Button";
import Password from "../../../common/Formik/Password/Password";
import styles from "../../../layouts/OnboardLayout/OnboardLayout.module.scss";
import { resetPasswordAction } from "../../../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Messages } from "../../../../utils/constants";
import { LeftArrowIcon } from "../../../../assets/icons/svgicons";

const ResetPassword = () => {
  const dispatch = useDispatch();
  const history = useNavigate();
  const navigate = useNavigate();
  const signUpData = useSelector((state) => state?.persist?.signUpData);

  const noSpacesInPassword = (value) => !value || !/\s/.test(value);

  const validationSchema = Yup.object({
    password: Yup.string()
      .label("Password")
      .required("Password is required")
      .test("no-spaces", "space is not allowed", noSpacesInPassword)
      .min(8, Messages?.passwordOfSixCharacters)
      .matches(Messages?.passwordTextChar, Messages?.passwordCharacters)
      .max(40, Messages?.passwordMaxCharacters)
      .oneOf([Yup.ref("confirmPassword")], "Password doesn't match"),
    confirmPassword: Yup.string()
      .label("Confirm Password")
      .required("Confirm Password is required")
      .test("no-spaces", "space is not allowed", noSpacesInPassword)
      .min(8, Messages?.passwordOfSixCharacters)
      .oneOf([Yup.ref("password")], "Password doesn't match"),
  });
  const initialValues = {
    password: "",
    confirmPassword: "",
  };
  const handleSubmit = async (values, resetForm) => {
    const dataObj = {
      username: await signUpData?.username,
      newPassword: values.password,
      confirmPassword: values.confirmPassword,
      ipAddress: "FORGOTPASSWORD",
      deviceType: 0,
    };
    try {
      const response = await dispatch(resetPasswordAction(dataObj));
      if (response?.status === 200) {
        history("/");
      }
    } catch (error) {
      resetForm();
      console.log("Something went wrong:", error);
    }
  };
  return (
    <>
      <div className={styles.onboard_box}>
        <Button
          variant='without_bg_border'
          className='backbtn'
          type="button"
          onClick={() => navigate(-1)}
        >
          <LeftArrowIcon />
          Back
        </Button>
        <h2>Reset your password</h2>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {(formik) => (
            <form onSubmit={(e) => { e.preventDefault(); e.stopPropagation(); }}>
              <Password
                control="input"
                className={styles.input}
                formik={formik}
                name="password"
                placeholder="••••••••••"
                label="Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.password}
              />
              <Password
                control="input"
                className={styles.input}
                formik={formik}
                name="confirmPassword"
                placeholder="••••••••••"
                label="Confirm Password"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.confirmPassword}
              />
              <div className={`${styles.submit_btn} mb-0`}>
                <Button
                  fluid
                  type="button"
                  onClick={(e) => {
                    formik.handleSubmit(e);
                  }}
                >
                  Continue
                </Button>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </>
  );
};

export default ResetPassword;
